<template>
    <div class="btnGroup">
        <div class="row center" v-if="uid != userInfoId&&liked === false ">
			<span @click="dianzan" v-show="state == 'a'" href="###" class="item base-btn">
				 为他点赞 >
			</span>
        </div>


        <div class="row center" v-if="uid == userInfoId " @click="share">
			<span href="###" class="item base-btn">
				 邀请好友点赞 >
			</span>
        </div>
        <div class="row center" v-if="uid == userInfoId && try_chou ">
            <a :href="try_chou" class="item base-btn">
                参与抽奖 >
            </a>
        </div>
        <div class="row center" v-if="uid == userInfoId || liked === true  ">
            <router-link to="/home" href="###" class="item base-btn">
                查看所有试用 >
            </router-link>
        </div>


        <div class="row center" v-if="uid == userInfoId  ">
            <router-link :to="`/detail/`+detailId" href="###" class="item base-btn">
                返回当前试用 >
            </router-link>
        </div>


        <div class="row center" v-if="uid != userInfoId&&liked === true">
            <router-link :to="`/detail/`+detailId" href="###" class="item base-btn">
                我也要免费申请 >
            </router-link>
        </div>

    </div>
</template>

<script>
    import {EventBus} from "../event-bus.js";
    import {mapState} from 'vuex'

    export default {
        name: 'btnGroup',
        data() {
            return {
                state: 'a'
            }
        },
        beforeCreate() {

        },
        created() {
            //this.$store.commit('showQrCode');
            //console.log(['btnGroup',this.uid,this.userInfoId])


        },
        methods: {
            dianzan() {
                EventBus.$emit('dianzan', {});
            },
            share() {
                this.$store.commit('setState', {
                    showShare: true
                });
            }
        },
        computed: mapState({
            userInfoId: 'userInfoId',
            uid: 'uid',
            liked: 'liked',
            detailId: 'detailId',
            try_chou: 'try_chou'
        }),
        watch: {
            'userInfo.id'() {

            },
            'uid'() {

                console.log(['btnGroup', this.uid, this.userInfoId])
            }
        },
        components: {}
    }
</script>

<style lang="scss" scoped>
    .btnGroup {
        width: 100%;
        min-height: 2.1rem;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .row {
            .item {
                flex-shrink: 1;
                align-items: center;
            }
            .base-btn {
                font-size: .25rem;
                margin: 0.07rem;
            }
            &.center {
                justify-content: center;
            }
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
</style>
